import axios from "axios";
import request from "@/utils/request";
import { productIdApp } from "@/api/index";

// 复用 api/index.js 的 Chile（秘鲁/智利）模式：直连 aseanApi
const aseanApi = process.env.VUE_APP_BASE_USE_API;

// 通用：文件名兜底（与 api/index.js 的 getDateName 行为一致）
function getDateName() {
  const d = new Date();
  const pad = (n) => (n < 10 ? "0" + n : n);
  return (
    d.getFullYear() +
    pad(d.getMonth() + 1) +
    pad(d.getDate()) +
    pad(d.getHours()) +
    pad(d.getMinutes()) +
    pad(d.getSeconds())
  );
}

// 通用：blob 响应触发下载（与 api/index.js 的 handleDownloadFile 一致）
function handleDownloadFile(response, fileName) {
  let _fileName = "";
  try {
    const cd = response.headers["content-disposition"];
    if (cd) _fileName = cd.split("=")[1];
  } catch (e) {}
  fileName = fileName || getDateName() || _fileName;
  let type = response.headers["content-type"] || "";
  let extension = (_fileName || "xlsx").split(".").pop();
  fileName = fileName + "." + extension;
  let blob = {};
  if (response.config.responseType === "blob") {
    blob = new Blob([response.data], { type });
  } else {
    if (response.data) {
      blob = new Blob(["﻿" + response.data], { type });
    } else {
      blob = new Blob([response.data], { type });
    }
  }
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    let link = document.createElement("a");
    let evt = document.createEvent("HTMLEvents");
    evt.initEvent("click", false, false);
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(link.href);
  }
}

// ===== 中国台湾货物贸易 ===== （2026-07-13 新增；风格与秘鲁/智利/新西兰一致）

// 获取台湾报告国
export function getComRtData60(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeTaiwanData/getTaiwanReporters",
  });
}

// 获取台湾伙伴国
export function getComPtData60(params) {
  params.productId = productIdApp();
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeTaiwanData/getTaiwanPartners",
  });
}

// 获取台湾商品数据
export function getTaiwanProduction(params) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    params,
    method: "get",
    url: aseanApi + "/api/tradeTaiwanData/getTaiwanGoods",
  });
}

// 台湾-获取年份及月份（与秘鲁/智利同名同形）
export function getTaiwanTimeData(timeType, productId = productIdApp()) {
  return axios({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    method: "get",
    url:
      aseanApi +
      "/api/tradeTaiwanData/timeData?productId=" +
      productId +
      "&timeType=" +
      timeType,
  });
}

// 台湾 table 表格数据
export function getTaiwanTableData(params) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi + "/api/tradeTaiwanData/getTableData?productId=" + productIdApp(),
    method: "post",
    data: params,
  });
}

// 台湾 table 表格下载
export function taiwanTableDownload(params, fileName) {
  return request({
    baseURL: "/",
    headers: {
      "api-version": "V1",
    },
    url:
      aseanApi +
      "/api/tradeTaiwanData/taiwanTableDownload?productId=" +
      productIdApp() +
      "",
    method: "post",
    data: params,
    responseType: ["json", "blob"],
  }).then((res) => {
    handleDownloadFile(res, fileName);
  });
}